import AIProjectsLandingPage from "./AIProjectsLandingPage";

export default AIProjectsLandingPage;
